var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIAAQMAAADOtka5AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRF////y6Nrl3L9JQAAANVJREFUeJzt1jEOgkAQQFEIJLYeiZsBR/NIdBQSIFvCujGgBuT9YrLFzqsnz3aWAwAAAAAAAAAAAAAAcB3g1s/jUSX/18082gYAAAAAAAAAAPgNMCa3Yg0lAAAAAAAAAODwQOjclyoAAAAAAAAA4PtAeC0LawAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgK3A6wAAAAAAAAAAlwKKZ3ItVncHAAAAAAAAABwdCJ37UgUAAAAAAACIAu8EAHwEWAUAAAAAAAAAAPwpMAEyWfxbtoYEdgAAAABJRU5ErkJggg==",
    width: 512,
    height: 512,
    "data-name": "New Project"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqft);
export default __webpack_public_path__ + "static/media/sqft.2896436045db5a4c083dc302950c9756.svg";
export { ForwardRef as ReactComponent };